import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Air Con", href: "#aircon" },
  { label: "Electrical", href: "#electrical" },
  { label: "Work", href: "#work" },
  { label: "Reviews", href: "#reviews" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300 ${
        scrolled ? "bg-white/70 backdrop-blur-xl border-b border-black/5" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex items-center justify-between h-20">
        <a href="#top" data-testid="logo-link" className="flex items-center group">
          <img src="/brand/jd-mark.png" alt="JD Electrical Ltd" className="h-12 w-auto transition-transform duration-300 group-hover:scale-105" />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className="font-body text-sm font-medium text-ink/70 hover:text-ink transition-colors duration-200 relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-brand-yellow hover:after:w-full after:transition-[width] after:duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#aircon"
          data-testid="header-quote-btn"
          className="hidden md:inline-flex items-center rounded-full bg-ink px-6 py-3 font-body text-sm font-semibold text-white hover:bg-brand-blue active:scale-95 transition-[background-color,transform] duration-200"
        >
          Get a Quote
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-ink p-2"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="md:hidden bg-white border-b border-black/5 overflow-hidden"
        >
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(" ", "-")}`}
                className="py-3 font-body text-base text-ink border-b border-black/5 last:border-0"
              >
                {l.label}
              </a>
            ))}
          </div>
        </motion.div>
      )}
    </motion.header>
  );
};
